<template>
  <div class="dna">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
    :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 dna-item">
        <div class="searchStyle">
          <el-form :inline="true" :model="searchForm" label-position="top">
            <el-form-item label="采集编号" prop="collectNumber" >
              <el-input v-model="searchForm.collectNumber" placeholder="采集编号"></el-input>
            </el-form-item>
            <el-form-item label="科拉丁名" prop="sectionLatin" >
              <el-input v-model="searchForm.sectionLatin" placeholder="科拉丁名"></el-input>
            </el-form-item>
            <el-form-item label="科中文名" prop="sectionChinese" >
              <el-input v-model="searchForm.sectionChinese" placeholder="科中文名"></el-input>
            </el-form-item>
            <el-form-item label="种拉丁名" prop="growLatin" >
              <el-input v-model="searchForm.growLatin" placeholder="种拉丁名"></el-input>
            </el-form-item>
            <el-form-item label="种中文名" prop="growChinese" >
              <el-input v-model="searchForm.growChinese" placeholder="种中文名"></el-input>
            </el-form-item>
            <el-form-item label="资源类型" prop="resourceType" >
              <el-input v-model="searchForm.resourceType" placeholder="资源类型"></el-input>
            </el-form-item>
<!--            <el-form-item label="采集地点" prop="">-->
<!--              <el-input v-model="searchForm.user" placeholder="采集地点"></el-input>-->
<!--            </el-form-item>-->
            <div style="display: inline-block;" class="button">
              <el-button type="primary"  @click="onSubmit">查询</el-button>
              <el-button type="primary"  @click="backSubmit">返回</el-button>
            </div>
          </el-form>
        </div>
        <template v-if="tableData.length>0">
          <el-table
              :data="tableData" border
              style="width: 100%" :header-cell-style="{backgroundColor: '#eee',color: '#333'}">
            <el-table-column
                prop="collectNumber"
                header-align="center"
                align="center"
                label="采集编号">
            </el-table-column>
            <el-table-column
                prop="sectionChinese"
                header-align="center"
                align="center"
                label="科中文名" >
            </el-table-column>
            <el-table-column
                prop="sectionLatin"
                header-align="center"
                align="center"
                label="科拉丁名">
            </el-table-column>
            <el-table-column
                prop="growChinese"
                header-align="center"
                align="center"
                label="种中文名">
            </el-table-column>
            <el-table-column
                prop="growLatin"
                header-align="center"
                align="center"
                label="种拉丁名" >
            </el-table-column>
            <el-table-column
                prop="resourceType"
                header-align="center"
                align="center"
                label="资源类型">
            </el-table-column>
            <el-table-column
                label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totalPage">
          </el-pagination>
        </template>
        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>
      </div>
    </div>
  </div>

</template>

<script>
import { fetchList } from '@/network/germplasmAnimal/dna'
import breadcrumb from '@/components/breadcrumb'
export default {
  name: "dna",
  components: { breadcrumb },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      page: 1,
      pageSize: 10,
      totalPage: 0,
      tableData: [],
      type: 'dna',
      searchForm:{},
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'
    })
  },
  mounted() {
    this.getList()
  },

  created() {
    this.childName = '种质资源'
    this.childPath = this.$route.path
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        // type: this.type
      },this.searchForm)).then(response => {
        // console.log('123:',response)
        this.tableData = response.data.data.records
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    openDetail(id){
      this.$router.push({
        path: '/detail',
        params: {
          id: id,
          infoContent: this.infoContent
        },
        // query: {
        //   infoContent: this.infoContent
        // }
      })
      getObj(id).then(res => {
        // console.log(res.data.data)
        this.infoContent = res.data.data
      })
      // window.open('http://192.168.0.116:8887/information?id='+id,'_blank')
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: 'DNA'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    }
  }
}
</script>


<style scoped lang="scss">
@import "../../../assets/css/dna";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>